:host {
  display: block;
}

.icon-flags svg {
  fill: none;
}
